// components/ui/Input.tsx
import React from "react";
import { cn } from "../../utils/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  asChild?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ asChild = false, className = "", ...props }, ref) => {
    const Comp = asChild ? React.Fragment : "input";
    return <Comp ref={ref} className={cn("input", className)} {...props} />;
  },
);
Input.displayName = "Input";
